let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("fbkpl")).then(() => parcelRequire('cf3Mk'));